import React from 'react';
import PropTypes from 'prop-types';
import FormTemplate from '../../../dialogs_common/SetupTemplate';
import ExploreNearbyOpportunitiesChoice from '../redirect/ExploreNearbyOpportunitiesChoice';
import OfferResourceChoice from '../redirect/OfferResourceChoice';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func
};

export default function Form(props) {
  const {
    user,
    navigation,
    onNext,
    onPrevious,
    onSkip
  } = props;

  return (
    <div className="my-auto">
      <FormTemplate
        className="w-full"
        onPrevious={onPrevious}
        navigation={navigation}
        title="You're all set! Every connection makes a difference. How would you like to begin?"
        body={(
          <div className="flex flex-col space-x-0 space-y-6">
            <ExploreNearbyOpportunitiesChoice />
            <OfferResourceChoice />
          </div>
        )}
        footer={(
          <>
            {/*<div className="text-cs-orange-500 underline cursor-pointer mt-6 sm:mt-0 mr-0 sm:mr-12" onClick={onSkip}>*/}
            {/*  No, I'm here for another reason.*/}
            {/*</div>*/}
            {/*<PrimaryButton disabled={hasError} onClick={() => hasError ? setShowErrors(true) : onSubmit()}>*/}
            {/*  Yes, that's me!*/}
            {/*</PrimaryButton>*/}
          </>
        )}
      />
    </div>
  );
};
